<template>
	<div>
		<h2>
			<router-link to="/sites">
    			<i class="icon-minimal-left tim-icons" />
			</router-link>
			Inserisci cantiere
		</h2>
    	<site-form :model="model" :on-submit="addSiteSubmit" submit-message="Crea"></site-form>
  </div>
</template>
<script>
import SiteForm from '@/components/Sites/SiteForm.vue'
// import SitesTable from './SitesTable.vue';
import { mapState, mapActions } from 'vuex'


export default{
  computed: {
    ...mapState({
    })
  },
  components: {
    SiteForm
  },
  data() {
  	return {
  		model: {
  			name: '',
  			emails: [],
        files: []
  		}
  	}
  },
  methods: {
    ...mapActions('sites', {
      create: 'create',
    }),
    addSiteSubmit() {
    	this.create(this.model)
    },	
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
  },
}	
</script>